//This file contains all the API calls to the backend server.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiUrl } from "../apiEndPoints";
//============================================================================================================
//                                     GENERIC GET DATA API CALL
//============================================================================================================
const BaseUrl = getApiUrl();
export const getData = (controllerAndMethodUrl, signal) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${BaseUrl}${controllerAndMethodUrl}`;
    let apiResponse = {
        status: 0,
        message: "",
        data: {},
    };
    try {
        const response = yield fetch(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            signal,
        });
        apiResponse.status = response.status;
        apiResponse.message = response.statusText;
        if (!response.ok) {
            return apiResponse;
        }
        const data = yield response.json().catch(() => {
            apiResponse.status = 500;
            apiResponse.message = "Invalid JSON response";
            return apiResponse;
        });
        apiResponse.data = data;
        return apiResponse;
    }
    catch (error) {
        apiResponse.status = 500;
        if (error instanceof Error) {
            apiResponse.message = error.message;
        }
        else {
            apiResponse.message = "An unknown error occurred";
        }
        return apiResponse;
    }
});
//============================================================================================================
//                                     GENERIC CREATE DATA API CALL
//============================================================================================================
export const createData = (controllerAndMethodUrl, dataModel) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${BaseUrl}${controllerAndMethodUrl}`;
    let apiResponse = {
        status: 0,
        message: "",
        data: {},
    };
    try {
        const response = yield fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify(dataModel),
        });
        apiResponse.status = response.status;
        apiResponse.message = response.statusText;
        if (!response.ok) {
            const jsonError = yield response.json().catch(() => null);
            if (jsonError && typeof jsonError === "object" && "message" in jsonError) {
                apiResponse.message = jsonError.message;
            }
            return apiResponse;
        }
        const data = yield response.json().catch(() => {
            apiResponse.status = 500;
            apiResponse.message = "Invalid JSON response";
            return apiResponse;
        });
        apiResponse.data = data;
        return apiResponse;
    }
    catch (error) {
        apiResponse.status = 500;
        if (error instanceof Error) {
            apiResponse.message = error.message;
        }
        else {
            apiResponse.message = "An unknown error occurred";
        }
        return apiResponse;
    }
});
//============================================================================================================
//                                     GENERIC UPDATE DATA API CALL
//============================================================================================================
export const updateData = (controllerAndMethodUrl, dataModel) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${BaseUrl}${controllerAndMethodUrl}`;
    let apiResponse = {
        status: 0,
        message: "",
        data: false,
    };
    try {
        const response = yield fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify(dataModel),
        });
        apiResponse.status = response.status;
        apiResponse.message = response.statusText;
        if (!response.ok) {
            const jsonError = yield response.json().catch(() => null);
            if (jsonError && typeof jsonError === "object") {
                if ("message" in jsonError) {
                    apiResponse.message = jsonError.message;
                }
                if ("errors" in jsonError) {
                    apiResponse.errors = jsonError.errors;
                }
                if ("error" in jsonError) {
                    apiResponse.error = jsonError.error;
                }
            }
            return apiResponse;
        }
        apiResponse.data = true;
        return apiResponse;
    }
    catch (error) {
        apiResponse.status = 500;
        if (error instanceof Error) {
            apiResponse.message = error.message;
        }
        else {
            apiResponse.message = "An unknown error occurred";
        }
        return apiResponse;
    }
});
//============================================================================================================
//                                     GENERIC DELETE DATA API CALL
//============================================================================================================
export const deleteData = (controllerAndMethodUrl, dataModel) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${BaseUrl}${controllerAndMethodUrl}`;
    let apiResponse = {
        status: 0,
        message: "",
        data: false,
    };
    try {
        const response = yield fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify(dataModel),
        });
        apiResponse.status = response.status;
        apiResponse.message = response.statusText;
        if (!response.ok) {
            return apiResponse;
        }
        apiResponse.data = true;
        return apiResponse;
    }
    catch (error) {
        apiResponse.status = 500;
        if (error instanceof Error) {
            apiResponse.message = error.message;
        }
        else {
            apiResponse.message = "An unknown error occurred";
        }
        return apiResponse;
    }
});
